(function () {
  function random(min, max) {
    return Math.random() * (max - min) + min;
  }

  function buildStars(container, count) {
    var fragment = document.createDocumentFragment();

    for (var i = 0; i < count; i++) {
      var star = document.createElement('span');
      star.className = 'star';
      star.style.setProperty('--x', random(0, 100).toFixed(2) + '%');
      star.style.setProperty('--y', random(0, 100).toFixed(2) + '%');
      star.style.setProperty('--size', random(1, 3).toFixed(2) + 'px');
      star.style.setProperty('--duration', random(2.5, 6).toFixed(2) + 's');
      star.style.setProperty('--delay', random(0, 6).toFixed(2) + 's');
      star.style.setProperty('--peak', random(0.35, 0.75).toFixed(2));
      fragment.appendChild(star);
    }

    container.appendChild(fragment);
  }

  function spawnShootingStar(container) {
    var star = document.createElement('span');
    star.className = 'shooting-star';
    // Fixed horizontal origin + fixed travel vector (set in CSS) keep every
    // shooting star moving in the same direction; only the vertical start
    // position varies, so they don't all launch from the same spot.
    star.style.setProperty('--start-x', '75%');
    star.style.setProperty('--start-y', random(2, 55).toFixed(2) + '%');

    var remove = function () {
      star.remove();
    };
    star.addEventListener('animationend', remove, { once: true });
    // Fallback in case animationend never fires (e.g. backgrounded tab).
    setTimeout(remove, 1500);

    container.appendChild(star);
  }

  function scheduleShootingStar(container) {
    var delay = random(3000, 6000);

    setTimeout(function () {
      spawnShootingStar(container);
      scheduleShootingStar(container);
    }, delay);
  }

  function init() {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var container = document.createElement('div');
    container.className = 'night-sky';
    container.setAttribute('aria-hidden', 'true');

    var starCount = window.innerWidth < 750 ? 30 : 65;
    buildStars(container, starCount);

    document.body.appendChild(container);

    if (!reduceMotion) {
      scheduleShootingStar(container);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
